var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlatlay3DNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,6.34a1.5,1.5,0,0,0-.83-1.25h0L10.67,1.34a1.48,1.48,0,0,0-1.34,0L1.84,5.08h0A1.5,1.5,0,0,0,1,6.34v7.23a1.49,1.49,0,0,0,.83,1.34l7.42,3.71.08,0a1.48,1.48,0,0,0,1.34,0l.08,0,7.42-3.71A1.49,1.49,0,0,0,19,13.57V6.34ZM10,2.68h0l6.48,3.24L10,9.16,3.52,5.92ZM2.5,13.57V7.09l6.75,3.37V17Zm15,0L10.75,17V10.46L17.5,7.09Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatlay3DNormal);
export default __webpack_public_path__ + "static/media/flatlay3d_normal.dfff1f19fbca9fab4fcb6ec35eed18b6.svg";
export { ForwardRef as ReactComponent };